(() => {
  const root = document.querySelector('.product-info--ocare-refresh');
  if (!root) return;

  // The V5 keeps Shopify's section order on every viewport. No DOM relocation:
  // sections remain reorderable and hideable from the theme customizer.
  root.dataset.ocareVersion = 'v5';
})();
